var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ((_vm.user && _vm.user.profile && _vm.user.profile.allow_messaging) && _vm.coachRoom.id)?_c('chat-window',{attrs:{"room":_vm.coachRoom,"recipient":_vm.recipient,"store":"ClientMessagingRooms"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }